import React from 'react'

import Link from '@Pure/Link'

import _ from 'lodash'

import { form as _base_form, list as _base_list } from '@Config/Blog/blog'

const base_form = _.cloneDeep(_base_form);
const base_list = _.cloneDeep(_base_list);

let form_config =
{
	...base_form,

	form_title: 'Article de blog juridique',

	fields:
	{
		...base_form.fields
	},

	hookComponentWillMount: function ()
	{
		const component = this, props = this.props, state = this.state;

		let form_data = component.state.form_data;

		form_data['blog[type]'] = 'legal';

		component.setState(
		{
			form_data: form_data
		});
	},

	get__createdMessage: function (model)
	{
		let link = '/gestion-des-CE/blog-juridique/';

		if (model.EC)
		{
			link = '/accueil/mon-espace/blog-juridique/';
		}

		var output =
		(
			<div className="c-message c-message--green">
				<div className="c-message__content">
					Le nouvel article <strong> { model.title } </strong> a été créé.
					{ ' ' }
					<Link className="c-link c-link--highlighted c-link--green"
						href={ link + model.id }>
						Voir l'article
					</Link>
				</div>
			</div>
		);

		return output;
	}
};

export const form = _.merge(base_form, form_config);

const list_config =
{
	title: 'Liste des articles de blog juridique',
	link: '/gestion-des-CE/blog-juridique',
	creation_link: '/gestion-des-CE/nouvel-article-de-blog-juridique',
	row_link_base: '/gestion-des-CE/blog-juridique/'
};

export const list = _.merge(_.cloneDeep(base_list), list_config);

let config =_.merge(_.cloneDeep(form), list);

export default config